export const DEFAULT_IMAGE_KEYS = {
  IMAGE_1: 1,
  IMAGE_2: 2,
  IMAGE_3: 3,
  IMAGE_4: 4,
  IMAGE_5: 5,
};

export const DEFAULT_IMAGES = {
  [DEFAULT_IMAGE_KEYS.IMAGE_1]: "live_01.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_2]: "live_02.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_3]: "live_03.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_4]: "live_04.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_5]: "live_05.jpg",
};

export const DEFAULT_TIMEZONE = {
  timeZone: "Asia/Tokyo",
  locale: "ja-JP",
};
